import { render, staticRenderFns } from "./liveRoot.vue?vue&type=template&id=0ab35ad5"
import script from "./liveRoot.vue?vue&type=script&lang=js"
export * from "./liveRoot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports